import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch(
  'T4R5EA2B0G',
  '83aca1c8ac5dac671f73d6b4b871ca04'
  // '6c36816e3c8a1c162f4661553d41c757'
);

export default searchClient;